import { WhitelabelKey } from "../globals";

export interface BrandingConfig {
  logo: string;
  searchStatusImage: string;
  headerImage: string;
  mobileHeaderImage: string;
  mobileHeaderImageHighContrast: string;
  faviconPrefix: string;
  title: string;
}

export const brandingConfig: Record<WhitelabelKey, BrandingConfig> = {
  nj: {
    logo: "assets/images/myhealthnj_logo.png",
    headerImage: "assets/images/myhealthnj_logo_white.png",
    searchStatusImage: "/assets/images/nj-logo-blue.png",
    mobileHeaderImage: "assets/images/myhealthnj_logo.png",
    mobileHeaderImageHighContrast: "assets/images/myhealthnj_logo.png",
    faviconPrefix: "/nj-favicon",
    title: "MyHealthNJ | Docket®",
  },
  /* default "docket" styles */
  default: {
    logo: "assets/images/Docket_Logo_Blue.png",
    headerImage: "assets/images/Docket_Logo_White.png",
    searchStatusImage: "/assets/images/Docket_Jim_Light.png",
    mobileHeaderImage: "assets/images/Docket_Logo_White.png",
    mobileHeaderImageHighContrast: "assets/images/Docket_Logo_Blue.png",
    faviconPrefix: "",
    title: "Docket®",
  },
};
